import React from 'react'
import { InstallType, useDefaultInstall } from '../../../../lib/hooks/install-eligibility'
import { ButtonCtaProps } from '../../../ui-lib/button'
import { ChromeInstallButton } from '../extension/chrome'
import { EdgeChromiumInstallButton } from '../extension/edgeChromium'
import { EdgePreChromiumInstallButton } from '../extension/edge-pre-chromium'
import { FirefoxInstallButton } from '../extension/firefox'
import { SafariInstallButton } from '../extension/safari'
import { AndroidInstallButton } from '../keyboard/android'
import { IPhoneInstallButton, IPadInstallButton } from '../keyboard/ios'
import { MacDownloadButton, WindowsDownloadButton } from '../llama'
import { NotAvailableButton } from '../unsupported/not-available-button'

export const DefaultInstallButton: React.FC<Omit<ButtonCtaProps, 'onClick'>> = (props) => {
  const preferredInstall = useDefaultInstall()

  switch (preferredInstall) {
    case InstallType.Android:
      return <AndroidInstallButton {...props} />
    case InstallType.IPad:
      return <IPadInstallButton {...props} />
    case InstallType.IPhone:
      return <IPhoneInstallButton {...props} />
    case InstallType.Windows:
      return <WindowsDownloadButton {...props} />
    case InstallType.Mac:
      return <MacDownloadButton {...props} />
    case InstallType.Chrome:
      return <ChromeInstallButton {...props} />
    case InstallType.Firefox:
      return <FirefoxInstallButton {...props} />
    case InstallType.Safari:
      return <SafariInstallButton {...props} />
    case InstallType.EdgeChromium:
      return <EdgeChromiumInstallButton {...props} />
    case InstallType.EdgePreChromium:
      return <EdgePreChromiumInstallButton {...props} />
    default:
      return <NotAvailableButton {...props} />
  }
}
